import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import ManageDealerLayer from "../../../components/Admin/ManageDealerLayer";

const ManageDealer = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <ManageDealerLayer />
      </MasterLayout>
    </>
  );
};

export default ManageDealer